import React from "react";
import "./About.scss";
import teamImage from "../../assets/images/background/contact_us_image.png";
import missionImage from "../../assets/images/background/contact_us_image.png";

const AboutPage = () => {
    return (
        <main className="about">
            {/* HERO SECTION */}
            <section className="about__hero">
                <div className="about__content">
                    <h1>About <span>TechADive</span></h1>
                    <p>
                        TechADive is a digital studio founded by <strong>Roy Sylvanus</strong>,
                        a Kenyan software engineer based in Poland. With extensive experience in
                        <strong> full-stack development</strong>, <strong>Android/iOS engineering</strong>,
                        and <strong>UI/UX design</strong>, TechADive creates scalable, high-quality
                        digital products that help businesses grow, connect, and innovate.
                    </p>
                </div>
                <img src={teamImage} alt="TechADive Team" className="about__image" />
            </section>

            {/* MISSION SECTION */}
            <section className="about__mission">
                <div className="about__mission-content">
                    <h2>Our Mission</h2>
                    <p>
                        To build modern, user-focused digital experiences that blend performance,
                        functionality, and design excellence. At TechADive, we aim to bridge the gap
                        between people and technology by crafting products that are reliable,
                        beautiful, and built to last.
                    </p>

                    <div className="about__stats">
                        <div>
                            <h3>+14</h3>
                            <p>Successful Projects</p>
                        </div>
                        <div>
                            <h3>+12</h3>
                            <p>Happy Clients</p>
                        </div>
                        <div>
                            <h3>5+</h3>
                            <p>Years of Experience</p>
                        </div>
                    </div>
                </div>
                <img src={missionImage} alt="Our Mission" className="about__image" />
            </section>
        </main>
    );
};

export default AboutPage;